module.exports = __webpack_public_path__ + "img/collection-engagementRingsHeart.e51d1ea.webp";